import React, { useState } from 'react';


const IAQChartSettingPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showChartSettingPopup,setshowChartSettingPopup] = useState<boolean>(false);

    const chartSettingToggleHandler = () => {
        setshowChartSettingPopup(!showChartSettingPopup);
    }
	
	return <Component showChartSettingPopup={showChartSettingPopup} chartSettingToggleHandler={chartSettingToggleHandler} {...props}/>;
};

export default IAQChartSettingPopupHOC;   